/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicoststotal2Inputs */

const en_aicoststotal2 = /** @type {(inputs: Aicoststotal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const de_aicoststotal2 = /** @type {(inputs: Aicoststotal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Aicoststotal2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicoststotal2 = /** @type {((inputs?: Aicoststotal2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicoststotal2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicoststotal2(inputs)
	return de_aicoststotal2(inputs)
});
export { aicoststotal2 as "aiCostsTotal" }